'use strict';

namespace Core {

    class SelectedAttractionSummary {

        attraction: any;

        public show :boolean = false;
        public tickets : {quantity :number, title :string}[];

        constructor(
            private $scope: ng.IScope
        ) {

            let stop = this.$scope.$watch('sas.attraction', v => {
                if (v) {
                    this.init(v);
                    stop();
                }
            });

        }

        private init(attraction :any) :void {
            let tickets :{quantity :number, title :string}[] = [];

            _.each(attraction, a => {
                _.each(a.CostBreakdown, i => {
                    tickets.push({quantity :i.Quantity, title :i.Description});
                });
            });
            this.tickets = tickets;
            this.show = tickets.length > 0;
        }

    }

    angular
        .module('core')
        .directive('selectedAttractionSummary', (): ng.IDirective => {

        return {
            scope: {},
            controller: SelectedAttractionSummary,
            controllerAs: 'sas',
            replace: true,
            bindToController: {
                attraction: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedAttractionSummary'
        };

    });

}
